import { DriverDetailsFormItem } from '../../components/manage-drivers/types';
import { DriverShortFormValues } from '../../utils/initialValues/get-driver-short-form-values';

// Legacy transforms lifted and shifted from the edit driver form (now ShortDriverForm)
export const getDriverFromShortForm = (formValues: DriverShortFormValues, driverDetails?: DriverDetailsFormItem) => ({
	...(driverDetails ?? ({} as DriverDetailsFormItem)),
	...formValues,
	isNewDriver: false,
	employmentStatus: formValues.employmentStatus === 'no' ? 'PT' : 'FT',
	otherEmploymentStatus: formValues.otherEmploymentStatus === 'no' ? 'PT' : 'FT',
});
